import { AuthLoginGuard } from './guard/auth-login.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { CreateProfileComponent } from './page/create-profile/create-profile.component';

export const routes: Routes = [
  { path: '', loadChildren: './page/main/main.module#MainModule', canActivate: [AuthLoginGuard] },
  { path: 'landing', loadChildren: './page/landing-page/landing-page.module#LandingPageModule' },
  { path: 'onboard', loadChildren: './page/onboard/onboard.module#OnboardModule' },
  { path: 'reset-password', loadChildren: './page/reset-password/reset-password.module#ResetPasswordModule' },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts